import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { findKey as _findKey } from 'lodash';

import { PolicyChangeRequestType } from '@amfam/shared/models';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { CopyService } from '@amfam/shared/utility/shared-services';

@Injectable({
  providedIn: 'root'
})
export class PolicyTransmuteService {
  constructor(
    private copyService: CopyService,
    private feature: FeatureFlagService
  ) {}

  public getChangeRequestTypeText(policyChangeType: PolicyChangeRequestType): string {
    const isNewTemplate = this.feature.isEnabled('request_change_new_template');
    // Extract the name from the Dictionary object.
    return _findKey(
      this.copyService.getCopy(isNewTemplate ? 'policy.requestTypes' : 'policy.requestType'),
      reqObj => reqObj === policyChangeType
    );
  }

  public initializeFormControls(groupName: UntypedFormGroup): AbstractControl[] {
    const formControlsArr: AbstractControl[] = [];
    Object.keys(groupName.controls).forEach(controlName => {
      formControlsArr.push(this.buildFormControl(groupName, controlName));
    });
    return formControlsArr;
  }

  private buildFormControl(groupName: UntypedFormGroup, controlName: string): AbstractControl {
    return groupName.controls[controlName];
  }
}
